import { leadInPlainText } from "@/lib/lead-in-html"

import { QUALITY_RATIONALE_EMPTY_MARK } from "./run-checks"
import type { QuestionQualityAlternate, QuestionQualityCheck } from "./types"

export interface QualitySuggestionLine {
  text: string
  replaces?: string
  optionId?: string
  isNew?: boolean
  isKept?: boolean
}

function plain(value: string | undefined): string {
  return leadInPlainText(value ?? "")
    .replace(/\s+/g, " ")
    .trim()
}

function realCurrent(value: string | undefined): string | undefined {
  const text = plain(value)
  if (!text || text === QUALITY_RATIONALE_EMPTY_MARK) return undefined
  return text
}

/** Suggested option wordings to show on the card. Empty for stem or setting recs. */
export function qualitySuggestionLines(
  check: QuestionQualityCheck,
  alternate: QuestionQualityAlternate,
): QualitySuggestionLine[] {
  const patch = alternate.patch
  if (!patch) return []
  const current = realCurrent(check.currentText ?? check.markText)
  const lines: QualitySuggestionLine[] = []
  const push = (
    textValue: string | undefined,
    replaces?: string,
    optionId?: string,
    isNew = false,
  ) => {
    const text = plain(textValue)
    if (!text) return
    const from = replaces
    const note = from && from !== text ? from : undefined
    const line: QualitySuggestionLine = { text }
    if (note) line.replaces = note
    else if (from && from === text) line.isKept = true
    if (optionId) line.optionId = optionId
    if (isNew) line.isNew = true
    lines.push(line)
  }

  if (patch.optionText) push(patch.optionText, current, check.optionId)
  if (patch.optionTexts?.length) {
    const single = patch.optionTexts.length === 1
    for (const row of patch.optionTexts) {
      push(
        row.text,
        realCurrent(row.from) ?? (single ? current : undefined),
        row.id,
      )
    }
  }
  if (patch.addOptions?.length) {
    for (const text of patch.addOptions) push(text, undefined, undefined, true)
  }
  return lines
}
